function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    );
}
document.addEventListener('DOMContentLoaded', function() {
    try {
      const observer = new IntersectionObserver(
          (entries) => {
              entries.forEach((entry) => {
                  const video = entry.target;
                  if (entry.isIntersecting) {
                      video.play();
                  } else {
                      video.pause();
                  }
              });
          },
          { rootMargin: "0px 0px 200px 0px" }
      );

      const allVideos = document.querySelectorAll("video");
      allVideos?.forEach((el) => {
          el.muted = true;
          const hasAutoplay = el.hasAttribute("autoplay");
          if (hasAutoplay) {
              observer.observe(el);
          }
      });
  } catch (e) {
      console.log("videoControl error", e);
  }
});
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

    if (summary.nextElementSibling.getAttribute('id')) {
        summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
            return;

        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(":focus-visible");
} catch (e) {
    focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
    const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener('keydown', (event) => {
        if (navKeys.includes(event.code.toUpperCase())) {
            mouseClick = false;
        }
    });

    window.addEventListener('mousedown', (event) => {
        mouseClick = true;
    });

    window.addEventListener('focus', () => {
        if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

        if (mouseClick) return;

        currentFocusedElement = document.activeElement;
        currentFocusedElement.classList.add('focused');

    }, true);
}

function pauseAllMedia(el = document) {
  el.querySelectorAll('.js-youtube, .js-vimeo, video').forEach((video) => {
    const component = video.closest('video-component');
    if (component && component.dataset.background === 'true') return;

    if (video.matches('.js-youtube')) {
      video.contentWindow.postMessage('{ "event": "command", "func": "pauseVideo", "args": "" }', '*');
    } else if (video.matches('.js-vimeo')) {
      video.contentWindow.postMessage('{ "method": "pause" }', '*');
    } else {
      video.pause();
    }
  });

  el.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
}

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true })
        this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
    return function () {
        return fn.apply(scope, arguments);
    }
};

Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function () {
        var value = this.provinceEl.getAttribute('data-default');
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function (e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none';
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function (selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function (selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement('option');
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};


class MenuDrawer extends HTMLElement {
    constructor() {
        super();

        this.mainDetailsToggle = this.querySelector('details');

        if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const parentMenuElement = detailsElement.closest('.has-submenu');
        const isOpen = detailsElement.hasAttribute('open');
        const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

        function addTrapFocus() {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
            summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
        }

        if (detailsElement === this.mainDetailsToggle) {
            if (isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
        } else {
            setTimeout(() => {
                detailsElement.classList.add('menu-opening');
                summaryElement.setAttribute('aria-expanded', true);
                parentMenuElement && parentMenuElement.classList.add('submenu-open');
                !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
            }, 100);
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });
        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event === undefined) return;

        this.mainDetailsToggle.classList.remove('menu-opening');
        this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
            details.removeAttribute('open');
            details.classList.remove('menu-opening');
        });
        this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
            submenu.classList.remove('submenu-open');
        });
        document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
        removeTrapFocus(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle);
    }

    onFocusOut(event) {
        setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        const parentMenuElement = detailsElement.closest('.submenu-open');
        parentMenuElement && parentMenuElement.classList.remove('submenu-open');
        detailsElement.classList.remove('menu-opening');
        detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
        removeTrapFocus(detailsElement.querySelector('summary'));
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute('open');
                if (detailsElement.closest('details[open]')) {
                    trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
                }
            }
        }

        window.requestAnimationFrame(handleAnimation);
    }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }

    openMenuDrawer(summaryElement) {
        this.header = this.header || document.getElementById('shopify-section-header');
        this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
        document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
        this.header.classList.add('menu-open');

        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });

        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus) {
        super.closeMenuDrawer(event, elementToFocus);
        this.header.classList.remove('menu-open');
    }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
    constructor() {
        super();
        this.querySelector('[id^="ModalClose-"]').addEventListener(
            'click',
            this.hide.bind(this, false)
        );
        this.addEventListener('keyup', (event) => {
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        if (this.classList.contains('media-modal')) {
            this.addEventListener('pointerup', (event) => {
                if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
            });
        } else {
            this.addEventListener('click', (event) => {
                if (event.target === this) this.hide();
            });
        }
    }

    connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
    }

    show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia();
    }

    hide() {
        document.body.classList.remove('overflow-hidden');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
    }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
    constructor() {
        super();

        const button = this.querySelector('button');

        if (!button) return;
        button.addEventListener('click', () => {
          console.log("this.getAttribute('data-modal')",this.getAttribute('data-modal'));
            const modal = document.querySelector(this.getAttribute('data-modal'));
            console.log("this.getAttribute('data-modal')-modal",modal);
            if (modal) modal.show(button);
        });
    }
}
customElements.define('modal-opener', ModalOpener);

if (!customElements.get('media-gallery')) {
    customElements.define('media-gallery', class MediaGallery extends HTMLElement {
        constructor() {
            super();
            this.elements = {
                liveRegion: this.querySelector('[id^="GalleryStatus"]'),
                viewer: this.querySelector('[id^="GalleryViewer"]'),
                thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
            }
            this.mql = window.matchMedia('(min-width: 750px)');
            if (!this.elements.thumbnails) return;

            this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
            this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
                mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
            });
            if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
        }

        onSlideChanged(event) {
            const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${event.detail.currentElement.dataset.mediaId}"]`);
            this.setActiveThumbnail(thumbnail);
        }

        setActiveMedia(mediaId, prepend) {
            const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
            this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
                element.classList.remove('is-active');
            });
            activeMedia.classList.add('is-active');

            if (prepend) {
                activeMedia.parentElement.prepend(activeMedia);
                if (this.elements.thumbnails) {
                    const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
                    activeThumbnail.parentElement.prepend(activeThumbnail);
                }
                if (this.elements.viewer.slider) this.elements.viewer.resetPages();
            }

            this.preventStickyHeader();
            window.setTimeout(() => {
                if (this.elements.thumbnails) {
                    activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
                }
                if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
                    activeMedia.scrollIntoView({ behavior: 'smooth' });
                }
            });
            this.playActiveMedia(activeMedia);

            if (!this.elements.thumbnails) return;
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            this.setActiveThumbnail(activeThumbnail);
            this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }

        setActiveThumbnail(thumbnail) {
            if (!this.elements.thumbnails || !thumbnail) return;

            this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
            thumbnail.querySelector('button').setAttribute('aria-current', true);
            if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

            this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }

        announceLiveRegion(activeItem, position) {
            const image = activeItem.querySelector('.product__modal-opener--image img');
            if (!image) return;
            image.onload = () => {
                this.elements.liveRegion.setAttribute('aria-hidden', false);
                this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
                    '[index]',
                    position
                );
                setTimeout(() => {
                    this.elements.liveRegion.setAttribute('aria-hidden', true);
                }, 2000);
            };
            image.src = image.src;
        }

        playActiveMedia(activeItem) {
            window.pauseAllMedia();
            const deferredMedia = activeItem.querySelector('.deferred-media');
            if (deferredMedia) deferredMedia.loadContent(false);
        }

        preventStickyHeader() {
            this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
            if (!this.stickyHeader) return;
            this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
        }

        removeListSemantic() {
            if (!this.elements.viewer.slider) return;
            this.elements.viewer.slider.setAttribute('role', 'presentation');
            this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
        }
    });
}

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (poster) {
          poster.addEventListener('click', this.loadContent.bind(this));
        } else {
          this.addObserver();
        }
    }
  /**
   * 添加观察器，等视口进来再加载
   */
  addObserver() {
    if ('IntersectionObserver' in window === false) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.loadContent(false, false, 'observer');
          observer.unobserve(this);
        }
      });
    }, { rootMargin: '0px 0px 1000px 0px' });

    observer.observe(this);
  }
  /**
   * Loads the deferred media.
   * @param {boolean} [focus=true] - Focus the deferred media element after loading.
   * @param {boolean} [pause=true] - Whether to pause all media after loading.
   * @param {string} [loadTrigger='click'] - The action that caused the deferred content to load.
   */
  loadContent(focus = true, pause = true, loadTrigger = 'click') {
    if (pause) pauseAllMedia();
    if (this.getAttribute('loaded') !== null) return;

    this.loadTrigger = loadTrigger;
    const content = this.querySelector('template').content.firstElementChild.cloneNode(true);
    this.appendChild(content);
    this.setAttribute('loaded', '');

    const deferredEl = this.querySelector('video, model-viewer, iframe');
    if (deferredEl && focus) deferredEl.focus();
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector('[id^="Slider-"]');
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.enableSliderLooping = false;
        this.currentPageElement = this.querySelector('.slider-counter--current');
        this.pageTotalElement = this.querySelector('.slider-counter--total');
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');
        this.slideLine = this.querySelector('.slider-counter--line');

        if (!this.slider || !this.nextButton) return;

        this.initPages();
        const resizeObserver = new ResizeObserver(entries => this.initPages());
        resizeObserver.observe(this.slider);

        this.slider.addEventListener('scroll', this.update.bind(this));
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
        if (this.sliderItemsToShow.length < 2) return;
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        this.slidesPerPage = Math.floor(((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset) + 0.012);//+0.012 去误差
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
        this.update();
    }

    resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.initPages();
    }

    update() {
        const previousPage = this.currentPage;
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
        if (this.currentPageElement && this.pageTotalElement) {
            this.currentPageElement.textContent = this.currentPage;
            this.pageTotalElement.textContent = this.totalPages;
        }

        if (this.currentPage != previousPage) {
            this.dispatchEvent(new CustomEvent('slideChanged', {
                detail: {
                    currentPage: this.currentPage,
                    currentElement: this.sliderItemsToShow[this.currentPage - 1]
                }
            }));
        }

        if (this.enableSliderLooping) return;

        if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
            this.prevButton.setAttribute('disabled', 'disabled');
        } else {
            this.prevButton.removeAttribute('disabled');
        }

        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
            this.nextButton.setAttribute('disabled', 'disabled');
        } else {
            this.nextButton.removeAttribute('disabled');
        }
        this.slideLine && (this.slideLine.style.width = `${(this.currentPage / this.totalPages) * 100}%`);
    }

    isSlideVisible(element, offset = 0) {
        const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
        return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }

    onButtonClick(event) {
        event.preventDefault();
        const step = event.currentTarget.dataset.step || 1;
        this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
        this.slider.scrollTo({
            left: this.slideScrollPosition
        });
    }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
    constructor() {
        super();
        this.sliderControlWrapper = this.querySelector('.slider-buttons');
        this.enableSliderLooping = true;

        if (!this.sliderControlWrapper) return;

        this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
        if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

        this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
        this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
        this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
        this.setSlideVisibility();

        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    }

    setAutoPlay() {
        this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
        this.autoplaySpeed = this.slider.dataset.speed * 1000;

        this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
        this.addEventListener('mouseover', this.focusInHandling.bind(this));
        this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
        this.addEventListener('focusin', this.focusInHandling.bind(this));
        this.addEventListener('focusout', this.focusOutHandling.bind(this));

        this.play();
        this.autoplayButtonIsSetToPlay = true;
    }

    onButtonClick(event) {
        super.onButtonClick(event);
        const isFirstSlide = this.currentPage === 1;
        const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

        if (!isFirstSlide && !isLastSlide) return;

        if (isFirstSlide && event.currentTarget.name === 'previous') {
            this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
        } else if (isLastSlide && event.currentTarget.name === 'next') {
            this.slideScrollPosition = 0;
        }
        this.slider.scrollTo({
            left: this.slideScrollPosition
        });
    }

    update() {
        super.update();
        this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
        this.prevButton.removeAttribute('disabled');
        console.log("this.sliderItemsToShow11", this.sliderControlButtons);

        if (!this.sliderControlButtons.length) return;

        this.sliderControlButtons.forEach(link => {
            link.classList.remove('slider-counter__link--active');
            link.removeAttribute('aria-current');
        });
        this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
        this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }

    autoPlayToggle() {
        this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
        this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
        this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }

    focusOutHandling(event) {
        const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
        if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
        this.play();
    }

    focusInHandling(event) {
        const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
        if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
            this.play();
        } else if (this.autoplayButtonIsSetToPlay) {
            this.pause();
        }
    }

    play() {
        this.slider.setAttribute('aria-live', 'off');
        clearInterval(this.autoplay);
        this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }

    pause() {
        this.slider.setAttribute('aria-live', 'polite');
        clearInterval(this.autoplay);
    }

    togglePlayButtonState(pauseAutoplay) {
        if (pauseAutoplay) {
            this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
            this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
        } else {
            this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
            this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
        }
    }

    autoRotateSlides() {
        const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
        this.slider.scrollTo({
            left: slideScrollPosition
        });
    }

    setSlideVisibility() {
        this.sliderItemsToShow.forEach((item, index) => {
            const button = item.querySelector('a');
            if (index === this.currentPage - 1) {
                if (button) button.removeAttribute('tabindex');
                item.setAttribute('aria-hidden', 'false');
                item.removeAttribute('tabindex');
            } else {
                if (button) button.setAttribute('tabindex', '-1');
                item.setAttribute('aria-hidden', 'true');
                item.setAttribute('tabindex', '-1');
            }
        });
    }

    linkToSlide(event) {
        event.preventDefault();
        console.log('linkToSlidelinkToSlide');
        const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({
            left: slideScrollPosition
        });
    }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.isCartDrawer = this.dataset.section.includes('cart-drawer');//是否是弹窗里的商品
        this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange(event) {
        this.updateOptions(event);
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateStock();
        if (event.target.closest('fieldset.bundle')) {
            return;
        }
        console.log("this.currentVariant", this.currentVariant);
        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
            if (this.isCartDrawer) {
                this.renderProductInfo();
            }
        } else {
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
        }
    }
    updateStock(){
      const dom=this.querySelector('.inventoryWrapper');
      const {id}= this.currentVariant||{};
      if(!dom){return};
      if(typeof window.variantStock[id]==='number') {
        let text=dom.querySelector('p span');
        if (text) {
          text.innerHTML = variantStock[id]
        };
        if((variantStock[id]<6)&&(variantStock[id]>0)){
          dom.classList.remove('hidden');
        }else{
          dom.classList.add('hidden');
        }
      }else{
        dom.classList.remove('hidden');
      }
    }
    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;
        if (this.isCartDrawer) {
            const mediaGallery = document.querySelector(`#Item-${this.dataset.section} img`);
            mediaGallery.src = `${this.currentVariant.featured_image.src}&width=180`;
        } else {
            const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
            mediaGallery && (mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

            const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
            if (!modalContent) return;
            const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
            modalContent.prepend(newMediaModal);
        }
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false' || this.isCartDrawer) return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;

        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
        if (this.isCartDrawer) {
            //更新当前选中属性
            const selectElement0 = this.querySelector('#Option-cart-drawer-0');
            const selectElement = this.querySelector('#Option-cart-drawer-1');
            const colorIcon = this.querySelector('#colorIcon-cart-drawer-0');
            this.updateMasterId();
            selectElement0.querySelectorAll('option').forEach((option) => {
                if (option.selected) {
                    colorIcon.style.backgroundImage = `url(${option.dataset.colorBg || ''})`;
                    colorIcon.style.backgroundColor = option.dataset.color || '#f5f5f5';
                }
            });

            if (selectElement && this.options.length > 1) {
                const option1 = this.options[0];//相当于颜色
                let option1Arr = [];
                (this.getVariantData() || []).forEach((variant) => {
                    if (variant.option1 === option1) {
                        option1Arr.push(variant);
                    }
                });
                const options = selectElement.querySelectorAll('option');
                options.forEach(option => {
                    option.removeAttribute('disabled');
                    const item = option1Arr.find((variant) => variant.options[1] === option.value);
                    if (!item || item.available === false) {
                        option.setAttribute('disabled', 'disabled');
                    }
                });
            };
            this.toggleAddButton(!(this.currentVariant && this.currentVariant.available), window.variantStrings.soldOut);
            return
        };
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const destination = document.getElementById(`price-${this.dataset.section}`);
                const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                if (source && destination) destination.innerHTML = source.innerHTML;
                const price = document.getElementById(`price-${this.dataset.section}`);
                if (price) price.classList.remove('visibility-hidden');
                this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
            });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.innerHTML = price.classList.add('visibility-hidden');
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('variant-selects', VariantSelects);
class VariantRadios extends VariantSelects {
    constructor() {
        super();
        // const colorFieldset = this.querySelector('fieldset[color]');
        // if (colorFieldset) {
        //     const currentColor = Array.from(colorFieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        //     colorFieldset.querySelector('.current-color').innerHTML = currentColor;
        // }
        const colorFieldset = this.querySelectorAll('fieldset[color]');

        if (colorFieldset.length) {
            for (let i = 0; i < colorFieldset.length; i++) {
                let legendDom = colorFieldset[i].querySelector("legend")
                const currentColor = Array.from(colorFieldset[i].querySelectorAll('input')).find((radio) => radio.checked)?.value;
                if (currentColor) {
                    legendDom.querySelector('.current-color').innerHTML = ": " + currentColor;
                    // break;
                } else {
                    legendDom.querySelector('.current-color').innerHTML = "";
                }
            }
        }

        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        let options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
        });
        this.options = options.filter(item => {
            return !!item
        })
        if (this.options[2]) {
            // this.querySelectorAll('label.color').forEach((item) => {
            //     item.classList.add('hidden');
            // });
            // this.querySelectorAll('input.color').forEach((item) => {
            //     item.classList.add('hidden');
            // });
            const activeVariants = this.getVariantData().filter((variant) => {
                return variant.option1.toLowerCase() == this.options[0].toLowerCase()
            });
            activeVariants.forEach((variant, index) => {
                this.querySelector(`label[data-value="${variant.option2}"]`).classList.remove('hidden');
                this.querySelector(`input[value="${variant.option2}"]`).classList.remove('hidden');

                if (index == 0) {
                    this.querySelector(`input[value="${variant.option2}"]`).checked = true;
                    this.currentVariant = variant;
                    this.updateURL();
                    this.updateVariantInput();
                    // colorFieldset.querySelector(`.current-color${num}`).innerHTML = this.querySelector(`input[value="${variant.option2}"]`).value;
                    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
                        .then((response) => response.text())
                        .then((responseText) => {
                            const html = new DOMParser().parseFromString(responseText, 'text/html');
                            const destination = document.getElementById(`price-${this.dataset.section}`);
                            const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                            if (source && destination) destination.innerHTML = source.innerHTML;
                            const price = document.getElementById(`price-${this.dataset.section}`);
                            if (price) price.classList.remove('visibility-hidden');
                            this.toggleAddButton(false, '', true)
                            this.updateMedia();
                            this.updateColor();
                            const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
                        });
                    this.updateShareUrl();
                }
            })
        }
    }
    updateColor() {
        const colorFieldset = this.querySelectorAll('fieldset[color]');

        if (colorFieldset.length) {
            for (let i = 0; i < colorFieldset.length; i++) {
                let legendDom = colorFieldset[i].querySelector("legend")
                const currentColor = Array.from(colorFieldset[i].querySelectorAll('input')).find((radio) => radio.checked)?.value;
                if (currentColor) {
                    legendDom.querySelector('.current-color').innerHTML = ": " + currentColor;
                    // break;
                } else {
                    legendDom.querySelector('.current-color').innerHTML = "";
                }
            }
        }
    }
    filterByValue(key, val) {
        //传入名称和值返回对应数据,例如传入key:option1(也可传入options中对应的index位置),val:red,就返回所有为red的variants
        const allArrays = this.getVariantData();
        let obj = { allList: null, availableList: null };//allList是所有的，availableList是所有的且有货的
        if ((key || key === 0) && val) {
            allArrays.forEach(item => {
                //判断key是否为数字
                let onValue = '';
                if (typeof key === 'number') {
                    onValue = item.options[key];
                } else {
                    onValue = item[key];
                }
                if (onValue === val) {
                    obj.allList = obj.allList || [];
                    obj.allList.push(item);
                    if (item.available) {
                        obj.availableList = obj.availableList || [];
                        obj.availableList.push(item);
                    }
                }
            })
        };
        return obj
    }
    changeChecked(options) {
        //当前size没有的时候，修改选中项为符合的第一个选项

        if (options.length > 1) {
            const av = this.getVariantData().filter((variant) => {
                return variant.option1.toLowerCase() == options[0].toLowerCase() && variant.option2.toLowerCase() == options[1].toLowerCase()
            });
            if (!av || av.length === 0) {
                const filterData = this.filterByValue(0, options[0]) || {};
                const newoptions = filterData.availableList || filterData.allList || [];
                this.options[1] = newoptions[0].options[1];
                const sizeFieldset = this.querySelector('fieldset[size]');
                if (sizeFieldset) {
                    const inputs = sizeFieldset.querySelectorAll('input');
                    inputs.forEach(input => {
                        if (input.value === options[1]) {
                            input.checked = true;
                        } else {
                            input.checked = false;
                        }
                    })
                }
            }
        }
    }
    updateOptions(event) {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        // const colorFieldset = this.querySelector('fieldset[color]');

        // if (colorFieldset) {
        //     const currentColor = Array.from(colorFieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        //     colorFieldset.querySelector('.current-color').innerHTML = currentColor;
        // }
        this.updateColor();
        let options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
        });
        this.options = options.filter(item => {
            return !!item
        });
        this.changeChecked(this.options)
        if (this.options[2]) {
            const activeVariants = this.getVariantData().filter((variant) => {
                return variant.option1.toLowerCase() == this.options[0].toLowerCase() && variant.option3.toLowerCase() == this.options[2].toLowerCase()
            });
            // this.querySelectorAll('label.color').forEach((item, index) => {
            //     item.classList.add('hidden');
            // });
            // this.querySelectorAll('input.color').forEach((item) => {
            //     item.classList.add('hidden');
            // });

            activeVariants.forEach((variant, index) => {
                this.querySelector(`label[data-value="${variant.option2}"]`).classList.remove('hidden');
                this.querySelector(`input[value="${variant.option2}"]`).classList.remove('hidden');
                if (event.target.closest('fieldset.bundle') && index == 0) {
                    this.querySelector(`input[value="${variant.option2}"]`).checked = true;
                    this.currentVariant = variant;
                    this.updatePickupAvailability();
                    this.updateMedia();
                    this.updateURL();
                    this.updateVariantInput();

                    // colorFieldset.querySelector('.current-color').innerHTML = this.querySelector(`input[value="${variant.option2}"]`).value;

                    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
                        .then((response) => response.text())
                        .then((responseText) => {
                            const html = new DOMParser().parseFromString(responseText, 'text/html');
                            const destination = document.getElementById(`price-${this.dataset.section}`);
                            const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                            if (source && destination) destination.innerHTML = source.innerHTML;
                            const price = document.getElementById(`price-${this.dataset.section}`);
                            if (price) price.classList.remove('visibility-hidden');
                            this.toggleAddButton(false, '', true)
                        });
                    this.updateShareUrl();
                }
            })

        }
    }

}

customElements.define('variant-radios', VariantRadios);


class fankaPriceProgress extends HTMLElement {
    static get observedAttributes() {
        return ["current-price"];
    }

    constructor() {
        super();
        this.priceRange = [];
        this.maxPrice = 0;
        this.currentPrice = this.getAttribute('current-price');
        this.headingElement = this.querySelector('.fanka-free-heading');
        this.descElement = this.querySelector('.fanka-free-desc');
        this.progressItem = this.querySelectorAll('.progress-item');
        this.progressElement = this.querySelector('.progress');
        this.currencySymbol = this.getAttribute('current-symbol');
        this.setPriceRange();
        this.setRangePosition();
    }


    attributeChangedCallback(name, old_price, new_price) {
        this.updateProgress(new_price);
        this.currentPrice = new_price;
    }

    setRangePosition() {
        const maxPrice = Math.max.apply(Math, this.priceRange);
        let lefts = [];//存储每个的宽度
        this.priceRange.forEach((price, index) => {
            const price_element = this.querySelector(`.progress-item[price="${price}"]`);
            const position = price / maxPrice * 100;
            lefts.push(position);
            price_element.style.width = index ? `${position - lefts[index - 1]}%` : `${position}%`;
            price_element.style.left = `${position}%`;
        })
        this.changeIcons();
    }

    setPriceRange() {
        this.progressItem.forEach((item) => {
            this.priceRange.push(item.getAttribute('price'));
        });
    }
    /**
     * 修改图标
     * @param {*} 
     */
    changeIcons() {
        setTimeout(() => {
            this.priceRange.forEach((price, index) => {
                const price_element = this.querySelector(`.progress-item[price="${price}"]`);
                let done = price_element.querySelector('.done');
                let lock = price_element.querySelector('.lock');
                if (this.currentPrice * 1 < price * 1) {
                    done.classList.add('hidden');
                    lock.classList.remove('hidden');
                } else {
                    done.classList.remove('hidden');
                    lock.classList.add('hidden');
                }
            })
        }, 10)
    }
    /**
     * 进度更新
     * @param {*} price //当前价格
     */
    updateProgress(price) {

        const maxPrice = Math.max.apply(Math, this.priceRange);
        const minPrice = Math.max.apply(Math, this.priceRange);

        this.progressElement && (this.progressElement.style.width = `calc(${price / maxPrice * 100}% - 5px)`);
        // this.progressElement.innerHTML = this.currencySymbol + price;


        const nextRange = this.priceRange.find(item => price * 1 < item * 1);
        this.headingElement && (this.headingElement.innerHTML = '');
        this.descElement && (this.descElement.innerHTML = '');

        if (this.headingElement && nextRange) {
            const progressItemNextEl = this.querySelector(`.progress-item[price="${nextRange}"]`);
            const text = progressItemNextEl.getAttribute('heading').replace("{price}", this.currencySymbol + (nextRange - price * 1).toFixed(2));
            this.headingElement.innerHTML = text;
        }

        let currentRange = 0;
        for (let i = 0; i < this.priceRange.length; i++) {
            if (price * 1 >= this.priceRange[i] * 1) {
                currentRange = this.priceRange[i];
            };
        }

        if (currentRange > 0 && this.descElement) {
            const progressItemCurrentEl = this.querySelector(`.progress-item[price="${currentRange}"]`);
            this.descElement.innerHTML = progressItemCurrentEl.getAttribute('desc');
        }

        this.setUnlockProducts(price);

        this.changeIcons();
    }

    setUnlockProducts(price) {

        const productsElement = this.querySelector('.fanka-free-products');
        const maskElement = productsElement.querySelector('.fanka-free-overlay');
        const productItemsElement = productsElement.querySelectorAll('.fanka-free-product');
        if (!productItemsElement[0]) { return }
        productItemsElement[0].style.display = 'block'
        let maskHeight = 0;
        productItemsElement.forEach((itemEl) => {
            const itemPrice = itemEl.getAttribute('price');
            if (price * 1 >= itemPrice * 1) {
                setTimeout(() => {
                    maskHeight += itemEl.clientHeight;;
                })
            }
        })
        setTimeout(() => {
            maskElement.style.top = `${maskHeight}px`;
            if (maskElement.style.top === '224px') {
                productItemsElement[0].style.display = 'none'
            }
            if (maskElement.style.top === '0px') {
                productItemsElement[0].style.display = 'block'
            }
        }, 10)

    }
}

customElements.define('fanka-price-progress', fankaPriceProgress);

/**
 * 赠品加入购物车
 */
class FankaFreeProductForm extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('form');
        this.form && (this.form.querySelector('[name=id]').disabled = false);
        this.form && (this.form.addEventListener('submit', this.onSubmitHandler.bind(this)));
        this.submitButton = this.querySelector('[type="submit"]');
        this.buttonSpace = this.querySelector('.button-space');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }
    onSubmitHandler(evt) {
        evt.preventDefault();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
            .then(response => response.json())
            .then(response => {
                /*
                this.submitButton.classList.add('hidden');
                this.buttonSpace.classList.remove('hidden');
                */
                this.cart.renderContents(response);
            });
    }
}
customElements.define('fanka-free-product-form', FankaFreeProductForm);

/**
 * 倒计时
 */
class fankaCountdown extends HTMLElement {
    constructor() {
        super();
        this.countdownTimer();
    }

    countdownTimer() {
        const nowTime = new Date();
        const endTime = new Date(this.getAttribute('end-time'));
        const leftTime = parseInt((endTime.getTime() - nowTime.getTime()) / 1000);
        if (leftTime <= 0) return false;
        let d = parseInt(leftTime / (24 * 60 * 60));
        let h = parseInt(leftTime / (60 * 60) % 24);
        let m = parseInt(leftTime / 60 % 60);
        let s = parseInt(leftTime % 60);

        d = d < 10 ? `0${d}` : d;
        h = h < 10 ? `0${h}` : h;
        m = m < 10 ? `0${m}` : m;
        s = s < 10 ? `0${s}` : s;

        d = d == '00' ? '' : `${d}d `;

        this.querySelector('.fanka-countdown__timer').innerHTML = `${d}${h}h ${m}m ${s}s`;
        setTimeout(() => {
            this.countdownTimer();
        }, 1000)
    }

}
customElements.define('fanka-countdown', fankaCountdown);

class CardColorOption extends HTMLElement {
    constructor() {
        super();
        this.option = this.querySelector('.color-option-item');
        this.allOptions = this.parentNode.querySelectorAll('.color-option-item')
        this.addEventListener('mouseover', this.activeColor.bind(this));
        this.addEventListener('mouseout', this.inactiveColor.bind(this));
        this.addEventListener('click', this.chooseColor.bind(this));
        this.variant = JSON.parse(this.dataset.variant);
        let element = this;
        while (element.parentElement) {
            if (element.parentElement.classList.contains('card-wrapper')) {
                this.ancestor = element.parentElement;
                break;
            }
            element = element.parentElement;
        }
        this.img1 = this.ancestor.querySelector('.motion-reduce1');
        this.img2 = this.ancestor.querySelector('.motion-reduce2');
        // this.img1_origin_src = this.img1.src
        // this.img1_origin_srcset = this.img1.srcset
        // this.img2 = this.ancestor.querySelector('.motion-reduce2');
        // this.img2_origin_src = this.img2.src
        // this.img2_origin_srcset = this.img2.srcset
    }
    activeColor(event) {
        // console.log('event', JSON.parse(this.dataset.variant.img_obj))
        // // 切换图片和价格

        let obj1 = this.variant.img_obj1;
        this.img1.src = obj1.featured_image
        this.img1.srcset = obj1.srcset

        let obj2 = this.variant.img_obj2;
        this.img2.src = obj2.featured_image
        this.img2.srcset = obj2.srcset
    }
    chooseColor() {
        this.allOptions.forEach(option => option.classList.remove('highlight'));
        this.option.classList.add('highlight');

        let obj = this.variant.img_obj1;
        this.img1.srcset = obj.srcset;
        this.img1.src = obj.src;
        let obj2 = this.variant.img_obj2;
        this.img2.srcset = obj2.srcset;
        this.img2.src = obj2.src;
        if (this.variant.url) {
            let links = this.ancestor.querySelectorAll('.full-unstyled-link');
            links.forEach(link => {
                link.href = this.variant.url
            })
        }
    }
    inactiveColor() {
        let light = JSON.parse(this.parentNode.querySelector('.highlight').parentNode.dataset.variant).img_obj1;
        let light2 = JSON.parse(this.parentNode.querySelector('.highlight').parentNode.dataset.variant).img_obj2;
        this.img1.src = light.featured_image
        this.img1.srcset = light.srcset

        this.img2.src = light2.featured_image
        this.img2.srcset = light2.srcset
    }
}

customElements.define('card-color-option', CardColorOption);

// 属性切换
class VariantAttributesSelects extends HTMLElement {
    constructor() {
        super();
        this.onPriceBox=this.querySelector('.price-box');
        this.addEventListener('change', this.onVariantChange);
    }
    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
    updateMasterId(event) {
        const {target}=event||{};
        this.currentVariant = this.getVariantData().find((variant) => {
            return variant.id === Number(target.value);
        });
    }
    onVariantChange(event) {
        this.updateMasterId(event);
        this.updateMedia();
        this.updatePrice(event);
        this.updateOptions(event);
    }
    getValue(event,type){
        const {target}=event||{};
        const selectedOption = target.options[target.selectedIndex];
        return selectedOption.dataset[type];
    }
    updateMedia() {
        const mediaGallery = document.querySelector(`#Item-${this.dataset.section} img`);
        mediaGallery.src = `${this.currentVariant.featured_image.src}&width=533`;
        mediaGallery.srcset = `${this.currentVariant.featured_image.src}&width=533`;
    }
    updatePrice(event){
        this.onPriceBox.innerHTML=this.getValue(event,'price');
    }
    updateOptions() {
        const aTag = document.querySelector(`#Item-${this.dataset.section} .card__content a`);
        aTag.href = `${this.dataset.url}?variant=${this.currentVariant.id}`;
    }
}
customElements.define('variant-attributes-selects', VariantAttributesSelects);